import CFAdminDataSelectTable from "../../components/CFAdminDataTable/CFAdminDataSelectTable";
import React, {useState} from "react";

function CFAdminUnSupportedVehicles ({columnValues, dataValues, handleSupportedVehicles} : any) {

    const [selectedRows, setSelectedRows] = useState<any>([]);

    const clickDiscardedButton = () => {
        handleSupportedVehicles(selectedRows);
    }

    return (
        <>
            <div className="ext1">
                There are <b>{dataValues.length}</b> unsupported vehicles. Please determine whether a new vehicle configurations need to be
                generated.
            </div>
            <div className="ext2">
                If an unsupported configuration is needed, resume support of the vehicle from the list by selecting its checkbox and clicking "Support Checked."
            </div>
            <p>Selected Rows: {Object.keys(selectedRows).length}</p>
            <CFAdminDataSelectTable
                columns={columnValues}
                data={dataValues}
                textModal={''}
                showFilter={false}
                showAdd={false}
                showPagination={false}
                showSelect={true}
                onRowSelect={(rows: any) => setSelectedRows(rows)}
                pageSize={1000}
            />
            <button data-testid="submit-discard" className="fvp-button button-right-align"
                    disabled={selectedRows.length === 0}
                    onClick={clickDiscardedButton}>
                Support Checked <i className="fvp-right-chevron"/>
            </button>
        </>
    )
}

export default CFAdminUnSupportedVehicles;
